import api from './axios';

export const dashboardAPI = {
  getSummary: () => api.get('/dashboard'),

  saveGoldPreference: (grams) =>
    api.put('/profile/gold-preference', { gold_preference_grams: grams }),
};
